import React, { useEffect, useState } from 'react'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { FieldGroup, FormCard, SubmitButtonMail } from '../../reusable'
import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { Checkbox } from '../../reusable/checkbox'
import { SignaturePad } from '../../reusable/sigPad'
import { sectionValidation } from '../../../helpers'
import { browserName, osName } from 'react-device-detect'
import { useClaimData } from '../../../claimProvider'
import { useSearchParams } from 'react-router-dom'
import { consentWordingV3, CURRENT_CONSENT_WORDING_VERSION } from '../../../data/consentWording'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'

export const SignatureSentinel = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup, validateSection } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    const [termsAccepted, setTermsAccepted] = useState(false)
    const [hasSignature, setHasSignature] = useState(false)
    const claim = useClaimData()

    const [searchParams] = useSearchParams()
    const chase_id = searchParams.get('chase_id')
    const agent = searchParams.get('agent')

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        let tempStepData = { ...stepData }
        tempStepData[dataToSave.field] = dataToSave.value
        setStepData(tempStepData)
        console.log('Updated stepData:', tempStepData)

        if (dataToSave.field === 'acceptTerms') {
            setTermsAccepted(dataToSave.value === 'yes')
        }

        return saved
    }

    const handleBack = () => {
        assignGroup('review')
    }

    // Checkbox inputs are stored as 'yes'/'no' strings in local stepData.
    // The sign payload sends every checkbox in the active consent wording version
    // as a boolean, regardless of whether the backend currently reads it — keeps
    // the payload consistent with the wording actually shown/agreed to at submission time.
    const toBool = (value: unknown) => value === 'yes' || value === true

    const buildSignClaim = () => {
        const consentValues = consentWordingV3.reduce<Record<string, boolean>>((acc, item) => {
            acc[item.fieldName] = toBool(stepData?.[item.fieldName])
            return acc
        }, {})

        return { ...claim, ...consentValues, consentWordingVersion: CURRENT_CONSENT_WORDING_VERSION }
    }

    // const redirectToOpenBanking = () => {
    //     console.log('claim.openBankingLink: ', claim)
    //     window.location.href = claim.openBankingLink
    // }

    // console.log(stepData)
    const animateBeforeAssign = (assignment: string) => {
        console.log(stepData)

        setTimeout(() => {
            assignGroup(assignment)
        }, 400)
    }

    const getCurrentStep = () => {
        // console.log('is active: ', isActive == 'signature')
        // console.log('true: ', isActive == 'signature' && claim?.sigData?.token.length > 0)
        // console.log('claim: ', claim)

        return isActive == 'signature' && claim?.sigData ? (
            <FieldGroup title="Sign Your CFA & LOA">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                    <SignaturePad
                        extraPayload={{
                            browser: browserName,
                            device: osName,
                            type: claim.leadOrigin,
                            chase_id,
                            agent,
                            claim: buildSignClaim(),
                        }}
                        additionalAction={() => animateBeforeAssign('openBanking')}
                        stepData={stepData}
                        requiredFields={consentWordingV3.map((item) => item.fieldName)}
                    >
                        <section className={`${styles.consentDisclosure} ${responsiveStyles.consentDisclosure}`}>
                            <h3>ViewThru consent</h3>
                            <p>
                                I understand that a number of entities working together are involved in gathering and
                                considering information to assess my anticipated claim. I therefore understand and agree
                                that:
                            </p>
                            <ul>
                                <li>
                                    ViewThru will carry out a ‘soft’ credit search about me with Credit Reference Agency
                                    Equifax Limited, and the results will be shared with Sentinel Legal for purposes of
                                    considering my anticipated claim. I’m aware that this will not impact my credit score.
                                </li>
                                <li>
                                    For the purpose of proceeding with the anticipated claim, I acknowledge that I am
                                    required to be based within the United Kingdom. Therefore, as part of assessing my
                                    eligibility for the anticipated claim, my IP address and/or mobile phone location data
                                    may be used to confirm that I am in the United Kingdom. These results will also be
                                    shared with Sentinel Legal.
                                </li>
                                <li>
                                    I understand that I may withdraw my consent at any time in respect of the above by
                                    contacting ViewThru, and this will not affect processing carried out before I withdrew
                                    consent.
                                </li>
                            </ul>
                            <p>
                                I acknowledge that I have read and agreed to{' '}
                                <a href="https://www.viewthru.co.uk/privacy" target="_blank" rel="noreferrer">
                                    ViewThru’s Privacy Policy
                                </a>
                                .{' '}
                                <a
                                    href="https://www.sentinellegal.co.uk/privacy-policy"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Sentinel Legal’s Privacy Policy
                                </a>{' '}
                                can also be accessed here.
                            </p>
                            <p>
                                By clicking the button below, I give my acknowledgement and consent to the above
                                provisions freely, expressly, and on an informed basis.
                            </p>
                        </section>
                        {consentWordingV3.map((item) => (
                            <div key={item.fieldName} style={{ marginBottom: '1rem' }}>
                                <Checkbox fieldName={item.fieldName} label={item.label} saveValue={preSaveValueFunct} />
                            </div>
                        ))}
                    </SignaturePad>
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
